import React from "react";
import "./Alerts.css";
import Marquee from "react-fast-marquee";

const Alerts = () => {
  return (
    <>
    {/* Scrolling */}
      <section className="scrolling-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-sm-12">
                <div className="">
                    <Marquee speed={50} gradient={false} direction="left" pauseOnHover>
                        🎓 Celebrating 50+ Years of Excellence | 💼 100% Placement Assistance | 🏆 NAAC A++ Accredited | 
                        🧪 Cutting-Edge Labs | 🌐 Explore Our Virtual Tour | 📚 World-Class Education | 
                        🌟 Excellence in Innovation
                    </Marquee>
                </div>
            </div>
          </div>
        </div>
      </section>
      {/* Alerts */}
      <section className="alerts-section">
        <div className="container">
          <div className="row align-items-center">
            {/* Date Block */}
            <div className="col-3 col-sm-2">
              <div className="event-date">
                <span className="day">28</span>
                <span className="month">JUN</span>
              </div>
            </div>

            {/* Links Block */}
            <div className="col-9 col-sm-10">
              <div className="alerts-links">
                <a href="downloads/category-b-2025/category-b-information-for-notice-board-22-05-2025.pdf">
                  Information regarding Admission in Category-B seats
                  (Management Quota)
                </a>
                <a href="downloads/2025/department-wise-minors-honours-offered-elegible-depts-2025-26.pdf">
                  Minors / Honours offered
                </a>
                <a href="downloads/2025/department-wise-stream-based-open-electives-offered-elegible-depts-2025-26.pdf">
                  Stream based open electives offered
                </a>
                <a href="placements/2024-2025.php">Placements 2024-2025</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Alerts;
